import { connect } from "react-redux";

import SurveyListGrid from "./SurveyListGrid";
import {
	// getSurveyEnseignesList,
	// getSurveySectorsList,
	// getSurveyModelesList,
	// getSurveyList,
	setArchiveSurvey,
	setSurvey,
	getSurveySorted
} from "./../../../../../redux/actions/surveyActions";
import { deleteSurvey } from "../../../../../redux/actions/surveyActions";

const mapStateToProps = (state, ownProps) => {
	return {
		surveyList: state.survey.surveyManager.surveyList || [],
		surveyListLoading: state.survey.surveyManager.surveyListLoading || false,
		sectorList: state.survey.surveyManager.secteurList || [],
		currentFilters: state.survey.surveyManager.currentFilters || {}
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		// getSurveyEnseignesList: enseignesList => {
		// 	dispatch(getSurveyEnseignesList(enseignesList));
		// },
		// getSurveySectorsList: sectorsList => {
		// 	dispatch(getSurveySectorsList(sectorsList));
		// },
		// getSurveyModelesList: modelesList => {
		// 	dispatch(getSurveyModelesList(modelesList));
		// },
		// getSurveyList: () => {
		// 	dispatch(getSurveyList());
		// },
		setArchiveSurvey: data => {
			dispatch(setArchiveSurvey(data));
		},
		setSurvey: () => {
			dispatch(setSurvey())
		},
		getSurveySorted: key => {
			dispatch(getSurveySorted(key))
		},
		deleteSurvey: key => {
			dispatch(deleteSurvey(key))
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(SurveyListGrid);



// WEBPACK FOOTER //
// src/components/survey/gestion/SurveyList/SurveyListGrid/SurveyListGridContainer.js